$(document).ready(function(){
    $(document).on('click', '.nav-menu-icon', function() {
      $('.header-sidebar').toggleClass('toggle');
      $('body').toggleClass('opened-drawer');
      $('.overlay-content').toggleClass('overlay');
      $('.overlay-content').css('backdrop-filter', 'blur(2px)')
    });
    
    $(document).on('click', '.close-button .icon-close', function() {
      $('.header-sidebar').removeClass('toggle');
      $('body').removeClass('opened-drawer');
      $('.overlay-content').removeClass('overlay');
    });
  
    $(document).mouseup(function (e) {
      var container = $('.header-sidebar');
      if (!container.is(e.target) && container.has(e.target).length === 0 && $('.header-sidebar').hasClass('toggle')) {
        $('.header-sidebar').removeClass('toggle')
        $('.overlay-content').removeClass('overlay')
        $('body').removeClass('opened-drawer');
     }
    });
});